/**
 * Built-in prompts for Ona AI interactions.
 * Centralized location for discoverability and maintenance.
 */

/**
 * Generates a prompt for Ona to diagnose and fix devcontainer build failures.
 * @param failureMessage - The error message from the failed devcontainer build
 */
export function getDevcontainerFailurePrompt(failureMessage?: string): string {
    const errorContext = failureMessage ? `\n\nError message:\n${failureMessage}` : "";
    return `The dev container failed to build.${errorContext}

Please diagnose and fix this issue by:
1. Running \`timeout 10 gitpod env devcontainer logs\` to see the build logs
2. Reading .devcontainer/devcontainer.json to understand the configuration
3. Checking for common issues like:
   - Privileged operations not supported (--privileged, --sysctl, --cap-add in runArgs)
   - Commands requiring sudo in postCreateCommand
   - Image pull failures or missing tags
   - Feature installation failures
4. Applying the appropriate fix
5. Rebuilding the devcontainer to verify`;
}
